import { render } from "./UserGuide.vue?vue&type=template&id=3dc80f64&scoped=true"
import script from "./UserGuide.vue?vue&type=script&lang=js"
export * from "./UserGuide.vue?vue&type=script&lang=js"

import "./UserGuide.vue?vue&type=style&index=0&id=3dc80f64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc80f64"]])

export default __exports__